export const OS_SUPPORT_LIST_REQ = 'OS_SUPPORT_LIST_REQ'
export const OS_SUPPORT_LIST_SET = 'OS_SUPPORT_LIST_SET'
export const OS_SUPPORT_LIST_SUCCESS = 'OS_SUPPORT_LIST_SUCCESS'
export const OS_SUPPORT_LIST_ERROR = 'OS_SUPPORT_LIST_ERROR'

export const OS_INSTALLATION_REQ = 'OS_INSTALLATION_REQ'
export const OS_INSTALLATION_SUCCESS = 'OS_INSTALLATION_SUCCESS'
export const OS_INSTALLATION_ERROR = 'OS_INSTALLATION_ERROR'

export const OS_DOWNLOAD_PROGRESS_SET = 'OS_DOWNLOAD_PROGRESS_SET'



// WEBPACK FOOTER //
// ./src/store/modules/os_support/os-support.type.js